import Vue from 'vue'
import Vuex, { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
const fb = require('./firebaseConfig.js')
import {timeConverter} from './components/Myfunctions'
import {timeConverterObject} from './components/Myfunctions'
import {timeConverterDateOnly} from './components/Myfunctions'
import axios from 'axios'
import createPersistedState from "vuex-persistedstate";

//State modules
import brewerEmailsStore from './storeBrewerEmails'

Vue.use(Vuex)

// handle page reload
fb.auth.onAuthStateChanged(user => {
    if (user) {
        store.commit('setCurrentUser', user)
        console.log("Fetching profile")
        store.dispatch('fetchUserProfile')

        //store.dispatch('getSalesTax')
        fb.usersCollection.doc(user.uid).onSnapshot(doc => {store.commit('setUserProfile', doc.data())})
        store.commit('setShowingSearchResults', false)
        store.commit('setShowingAllResults', true)
        store.commit('setDisplaySearchPhrase', "")
        store.commit('setDataLoadingInStoreStatus', true)

        //Clear store filters
        var filterObject={}
        var containers=[]
        var styles=[]
        var cat=""
        var price={min:0, max:1000}
        filterObject.cat=cat
        filterObject.styles=styles
        filterObject.containers=containers
        filterObject.price=price
        store.commit('setBeerFilter', filterObject)
    }
    //No user. Log out and empty evertything
    else{
        store.dispatch('clearData')
    } 
})

export const store = new Vuex.Store({
    modules: {
        brewerEmailsStore,
      },

    plugins: [createPersistedState()],
    state: {
        currentUser: null,
        userProfile: {},
        userProfileStatus:0,
        userInventory: [],
        userPromotedInventory:[],
        beersAvailable:{},
        posts: [],
        hiddenPosts: [],
        isBrewer: 0,
        userCart:[],
        cartCount:0,
        viewingBrewerId:'',
        viewingBrewerName:'',
        userMessagesArray:[],
        unreadCount:0,
        singleMessageThread:[],
        activeMessageThreadInfo:{},
        newBreweryOrdersCount:0,
        allBreweryOrders:[],
        pendingOrders:[],
        acceptedOrders:[],
        pastOrders:[],
        breweryConsumerOrders:[],
        brewersList:[],
        pubEvents : [],
        favoriteBrewersList:[],
        favoriteBeersList:[],
        breweryEvents:[],
        everyAvailableBeer:[],
        promotedBeers:[],
        deliverSoonCount:0,
        newOrders:[],
        activeOrders:[],
        completedOrders:[],
        newsFeed:[],
        dataLoadingInStoreStatus:'',
        promotionsEnabled:"Hello",
        allowDistributors:'',
        userAddressFromIP:'',
        allBrewersList:[],
        distributorBreweries:[],
        distributorBeers:[],
        distributorList:[],
        beerFilter:{
            cat:"",
            containers:[],
            price:{},
            styles:[],
        },
        showingSearchResults:false,
        showingAllResults:true,
        searchBeerList:[],
        displaySearchPhrase:'',
        allowInvoice:true,
        invoicesArray:[], //Array storing edited orders ready for invoicing
        ordersToInvoice:[], //Temporary array holding which orders have been selected for invoicing
        allExistingBeers:[],
        allowConsumers:false,
        checkoutCart:[],
        cartCost:0,
        consumerCart:[],
        consumerCartCount:0,
        consumerOrders:[],
        brewerServiceRequests:[],
        openServiceRequests:0,
        selectedConsumerWebsite:false, // 1 = business, 2 = consumer, undefined = not selected yet
        allowAdvertising:true,
        allowCoupons:true,
        //UI Version
        uiVersion:1,

        //Distributor brewery when managing
        selectedDistBrewery:{},

        //Forums
        allowForums:1,
        currentForumThreadId:'',

        //Sale items
        selectedSaleItem:{},
        createdItemForSale:{},

        //Camera image id
        cameraImageId:'',
        cameraImageUrl:'',
        capturedImages:{},

        //New user
        newUserEmail:"",
        newUserPassword:"",
        newUserIsBrewer:-10,
        newUserAddress:{
            street1:"",
            street2:"",
            city:"",
            state:"",
            zip:"",
            county:"",
            country:"",
        },
        newUserContactName:"",
        newUserContactPhone:"",
        newUserTermsAccepted:0,
        newUserCounties:[],
        newUserCompany:"",

    },
    actions: {
        setAppOptions({commit,state}){
            commit('setAllowDistributors', true)
            commit('setPromotionsEnabled', true)
            commit('setAllowInvoice', true)
            commit('setAllowConsumers', false)
            commit('setAllowAdvertising', true)
            commit('setUiVersion', 2)
            commit('setAllowForums', 0)
            commit('setAllowCoupons', true)
            
        },
        
        clearData({ commit }) {
            
            store.commit('setCurrentUser', null)
            store.commit('setUserProfile', {})
            store.commit('setUserProfileStatus', 0)
            store.commit('setEveryAvailableBeer', [])
            store.commit('setBrewersList', [])
            store.commit('setPromotedBeers', [])
            store.commit('setFavoriteBeersList', [])
            store.commit('setUserInventory', [])
            store.commit('setBrewersList', [])
            store.commit('setUserMessagesArray', [])
            store.commit('setNewsFeed',[])
            store.commit('setDataLoadingInStoreStatus', false)
            store.commit('setPubEvents', [])
            store.commit('setSingleMessageThread', [])
            store.commit('setBreweryEvents', [])
            store.commit('setUnreadCount', 0)
            store.commit('setPendingOrders', [])
            store.commit('setAcceptedOrders', [])
            store.commit('setPastOrders', [])
            store.commit('setNewOrders', [])
            store.commit('setActiveOrders', [])
            store.commit('setCompletedOrders', [])
            store.commit('setNewOrdersCount', 0)
            store.commit('setCartCount', 0)
            store.commit('setConsumerCartCount', 0)
            store.commit('setDeliverSoonCount', 0)
            store.commit('setDataLoadingInStoreStatus', false)
            store.commit('emptyCart', [])
            store.commit('setAllBrewersList',[])
            store.commit('setDistributorBreweries',[])
            store.commit('setDistributorBeers',[])
            store.commit('setInvoicesArray',[])
            store.commit('setOrdersToInvoice',[])
            store.commit('setAllExistingBeers',[])
            store.commit('setShowingSearchResults', false)
            store.commit('setShowingAllResults', true)
            store.commit('setCheckoutCart', [])
            store.commit('setConsumerCart', [])
            store.commit('setConsumerOrders', [])
            store.commit('setUserCartMultisize', [])
            
            //store.replaceState({})
            sessionStorage.clear();
            console.log("All data cleared")
            
            
        },
        

        fetchUserProfile({ commit, state }) {
            commit('setUserProfileStatus', 0)
            store.dispatch('setAppOptions')

            fb.usersCollection.doc(state.currentUser.uid)
                .onSnapshot(function(doc) {
                    store.commit('setUserProfile', doc.data())
                    store.commit('setIsBrewer', parseInt(state.userProfile.isbrewer))
                    store.commit('setUserProfileStatus', 1)
                    store.dispatch('getUserMessages2')

                    //Is a pub
                    if(state.userProfile.isbrewer==0){
                        store.dispatch('fetchBeersForUser')
                        store.commit('setIsBrewer',0)
                        //store.dispatch('fetchConsumerOrders')
                    }
                    
                    //Is a brewer
                    if (state.userProfile.isbrewer==1){
                        store.commit('setIsBrewer', 1)
                        store.dispatch('fetchBreweryInventory')
                        store.dispatch('fetchBreweryOrders')
                        store.dispatch('fetchBrewerServiceRequests')
                        //store.dispatch('fetchBreweryConsumerOrders')
                        //store.dispatch('fetchBreweryEvents')
                        store.commit('setDataLoadingInStoreStatus', false)
                    }

                    //Is a Rep
                    if (state.userProfile.isbrewer==10){
                        store.commit('setIsBrewer', 10)
                        store.dispatch('fetchDistributorBreweries')
                        store.dispatch('fetchDistributorBeers')
                        store.dispatch('fetchBreweryOrders')
                        store.dispatch('fetchBreweryInventory')
                        //store.dispatch('fetchBreweryConsumerOrders')
                        //store.dispatch('fetchBreweryEvents')
                        store.commit('setDataLoadingInStoreStatus', false)
                    }


                    //It's an authorized user
                    if (state.userProfile.isbrewer==20){
                        store.commit('setIsBrewer', 20)
                        store.dispatch('fetchBreweryInventory')
                        store.dispatch('fetchBreweryOrders')
                        store.dispatch('fetchBrewerServiceRequests')
                        store.commit('setDataLoadingInStoreStatus', false)
                    }

                    //Is a distributor
                    else if (state.userProfile.isbrewer==2){
                        store.commit('setIsBrewer', 2)
                        store.dispatch('fetchBreweryOrders')
                        store.dispatch('fetchDistributorBreweries')
                        store.dispatch('fetchDistributorBeers')
                        store.dispatch('fetchBrewerServiceRequests')
                        store.commit('setDataLoadingInStoreStatus', false)
                    }
                    
                    
                    /*
                    else{
                        store.commit('setFavoriteBrewersList', state.userProfile.favorites)
                        
                    } 
                    */
                    
                    //store.dispatch('fetchNewsFeed')
                    //store.commit('setDataLoadingInStoreStatus', false)
            });
            
        },

        /***************************************/
        /**** Fetch brewer sercice requests ****/
        /***************************************/
        fetchBrewerServiceRequests({ commit, state }) {
            
            fb.servicesCollection.where('brewerid','==',state.currentUser.uid).onSnapshot(querySnapshot => {
                var serviceRequests=[]
                var openServicesCount = 0
                store.commit('setBrewerServiceRequests',[])
                store.commit('setOpenServiceRequests',0)
                querySnapshot.forEach(doc => {
                    //Get minimum price
                    var serviceData = doc.data()
                    serviceData.docId = doc.id
                    //Format date
                    if (serviceData.createdOn) {
                        serviceData.date = timeConverterDateOnly(serviceData.createdOn.seconds)
                    }

                    //Add seller note
                    if(!serviceData.sellernote) serviceData.sellernote=""

                    //Create status of each service
                    if(serviceData.linecleaning){
                        if(serviceData.linecleaningcompleted==-1) serviceData.linecleaningstatus="Cancelled"
                        else if(serviceData.linecleaningcompleted==0){
                            openServicesCount++
                            serviceData.linecleaningstatus="Open"
                        } 
                        else if(serviceData.linecleaningcompleted==1) serviceData.linecleaningstatus="Complete"
                    }
                    if(serviceData.kegpickup){
                        if(serviceData.kegpickupcompleted==-1) serviceData.kegpickupstatus="Cancelled"
                        else if(serviceData.kegpickupcompleted==0){
                            openServicesCount++
                            serviceData.kegpickupstatus="Open"
                        } 
                        else if(serviceData.kegpickupcompleted==1) serviceData.kegpickupstatus="Complete"
                    }
                    if(serviceData.taphandles){
                        if(serviceData.taphandlescompleted==-1) serviceData.taphandlesstatus="Cancelled"
                        else if(serviceData.taphandlescompleted==0){
                            openServicesCount++
                            serviceData.taphandlesstatus="Open"
                        } 
                        else if(serviceData.taphandlescompleted==1) serviceData.taphandlesstatus="Complete"
                    }
                    if(serviceData.signage){
                        if(serviceData.signagecompleted==-1) serviceData.signagestatus="Cancelled"
                        else if(serviceData.signagecompleted==0){
                            openServicesCount++
                            serviceData.signagestatus="Open"
                        } 
                        else if(serviceData.signagecompleted==1) serviceData.signagestatus="Complete"
                    }
                    
                    serviceRequests.push(serviceData)
                    store.commit('setBrewerServiceRequests',serviceRequests)
                    store.commit('setOpenServiceRequests',openServicesCount)
                    //Add to brewers list
                })
            })

        },

        //For getting logos for first page
        fetchAllBrewersList({ commit, state }) {
            store.commit('setAllBrewersList',[])
            var localAllBrewers=[]

            //Ger breweries
            fb.usersCollection.where('isbrewer','>',0).where("counties", "array-contains", "San Diego").onSnapshot(querySnapshot => {
                querySnapshot.forEach(doc => {
                    var theBrewer = doc.data()
                    if(theBrewer.logoFileThumbnailURL){
                        theBrewer.uid = doc.id
                        theBrewer.hasBeers=0
                        //console.log("Brewery = " + theBrewer.company)
                        localAllBrewers = state.allBrewersList
                        const existingBrewerindex = localAllBrewers.findIndex(item => item.uid === theBrewer.uid);
                        if(existingBrewerindex > -1){
                            localAllBrewers.splice(existingBrewerindex, 1, theBrewer)

                        }
                        else {
                            localAllBrewers.push(theBrewer)
                        }
                        store.commit('setAllBrewersList',localAllBrewers)
                    }

                    })
                })
                //Get distributors
                fb.usersCollection.where('isbrewer','==',2).where("counties", "array-contains", "San Diego").onSnapshot(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        var theBrewer = doc.data()
                        if(theBrewer.logoFileThumbnailURL){
                            theBrewer.uid = doc.id
                            //console.log("Brewery = " + theBrewer.company)
                            localAllBrewers = state.allBrewersList
                            const existingBrewerindex = localAllBrewers.findIndex(item => item.uid === theBrewer.uid);
                            if(existingBrewerindex > -1){
                                localAllBrewers.splice(existingBrewerindex, 1, theBrewer)
    
                            }
                            else {
                                localAllBrewers.push(theBrewer)
                            }
                            store.commit('setAllBrewersList',localAllBrewers)
                        }
    
                        })
                    })
            
        },

        fetchDistributorBreweries({ commit, state }){
            var localAllBrewers=[]
            //Check if rep or brewer/distributor
            var theUidForInventory = state.currentUser.uid
            if(state.userProfile.isbrewer==10) theUidForInventory=state.userProfile.distributorid

            fb.distributorBrewersCollection.where('distributorId', '==', theUidForInventory).onSnapshot(querySnapshot => {
                querySnapshot.forEach(doc => {
                    var theBrewer = doc.data()
                    theBrewer.uid = doc.id
                    //console.log("Brewery = " + theBrewer.company)
                    //localAllBrewers = state.distributorBreweries
                    const existingBrewerindex = localAllBrewers.findIndex(item => item.uid === theBrewer.uid);
                        if(existingBrewerindex > -1){
                            localAllBrewers.splice(existingBrewerindex, 1, theBrewer)
                        }
                        else {
                            localAllBrewers.push(theBrewer)
                        }
                        store.commit('setDistributorBreweries',localAllBrewers)
                    })
                })

        },

        fetchDistributorBeers({ commit, state }){
            var localAllBeers=[]
            var theUidForInventory = state.currentUser.uid
            if(state.userProfile.isbrewer==10) theUidForInventory=state.userProfile.distributorid

            fb.beersCollection.where('distributorId', '==', theUidForInventory).onSnapshot(querySnapshot => {
                querySnapshot.forEach(doc => {
                    var theBeer = doc.data()
                    theBeer.docId = doc.id
                    //console.log("Got beer with ID = " + theBeer.docId)
                    //console.log("Brewery = " + theBrewer.company)
                    //localAllBrewers = state.distributorBreweries
                    const existingBeerindex = localAllBeers.findIndex(item => item.docId === theBeer.docId );
                        if(existingBeerindex > -1){
                            localAllBeers.splice(existingBeerindex, 1, theBeer)
                        }
                        else {
                            localAllBeers.push(theBeer)
                        }
                        store.commit('setDistributorBeers',localAllBeers)
                    })
                })

            
        },



        fetchNewsFeed({ commit, state }) {
            store.commit('setNewsFeed',[])

            var keyForNews
            if(store.state.userProfile.isbrewer==1||store.state.userProfile.isbrewer==2) keyForNews ='brewerId'
            else keyForNews ='pubId'

            fb.newsfeedCollection.where(keyForNews, '==', state.currentUser.uid).orderBy("createdOn", "desc").limit(20).onSnapshot(querySnapshot => {
                let localNewsFeed = []
                querySnapshot.forEach(doc => {
                    var newsData = doc.data()
                    newsData.date = timeConverter(newsData.createdOn.seconds)
                    localNewsFeed.push(newsData)
                    store.commit('setNewsFeed',localNewsFeed)
                })

            })
            
        },

        updateProfile({ commit, state }, data) {
            let name = data.name
            let company = data.company
            let street1 = data.street1
            let street2 = data.street2

            fb.usersCollection.doc(state.currentUser.uid).update({ name, company, street1, street2 }).then(user => {
                fb.beersCollection.where('uid', '==', state.currentUser.uid).get().then(docs => {
                    docs.forEach(doc => {
                        fb.beersCollection.doc(doc.id).update({
                            brewer: company
                        })
                    })
                })
            })
        },
        fetchBreweryInventory({ commit, state }, data){
            var today = new Date()
            var todayTime = today.getTime()

            //Check if rep or brewer/distributor
            var theUidForInventory = state.currentUser.uid
            if(state.userProfile.isbrewer==10) theUidForInventory=state.userProfile.distributorid

            fb.beersCollection.where('uid', '==', theUidForInventory).onSnapshot(querySnapshot => {
                let inventoryArray = []
                querySnapshot.forEach(doc => {
                    //console.log("Got update for ")
                    //console.log(doc.data())
                    let beer = doc.data()
                    beer.docId = doc.id

                    //Check if allowConsumers exists. If not , add it
                    if(!("allowConsumers" in beer)){
                        beer.allowConsumers="0"
                        beer.consumerSalesTax=7.75
                        beer.consumerDeliveryTime=2
                        beer.consumerDeliveryCost=4.99

                    } 
                    else beer.allowConsumers=beer.allowConsumers.toString()

                    if(!beer.deliveryMethod) beer.deliveryMethod=""
                    var promotionExpiresOn = beer.promotionExpiresOn
                    if((promotionExpiresOn>1000)&&(promotionExpiresOn>todayTime)){
                        beer.alreadyPromoted = true
                    } 
                    else beer.alreadyPromoted = false
                    inventoryArray.push(beer)
                })
                store.commit('setUserInventory', inventoryArray)
    
            })

        },
        fetchBreweryOrders({ commit, state }, data){
            store.commit('setNewOrdersCount',0)
            store.commit('setPendingOrders', [])
            store.commit('setAcceptedOrders', [])
            store.commit('setPastOrders', [])
            store.commit('setNewOrders', [])
            store.commit('setActiveOrders', [])
            store.commit('setAllBreweryOrders', [])

            //Check if rep or brewer/distributor
            var theUidForInventory = state.currentUser.uid
            if(state.userProfile.isbrewer==10||state.userProfile.isbrewer==20) theUidForInventory=state.userProfile.distributorid

            //First get all orders
            fb.ordersCollection.where('brewerid', '==', theUidForInventory).orderBy("createdOn", "desc").onSnapshot(querySnapshot => {
                store.commit('setNewOrdersCount',0)
                let localAllOrders = []
                querySnapshot.forEach(doc => {
                    store.commit('setNewOrdersCount',state.newBreweryOrdersCount+1)
                    let order = doc.data()
                    order.docId = doc.id
                    if(order.desiredDate){
                        order.desiredTime = new Date(order.desiredDate.seconds*1000)
                        order.deliveryTime = new Date(order.deliveryDate.seconds*1000)
                    } 
                    
                    order.displayStatus="Pending"
                    if (order.createdOn) {
                        order.orderDate = timeConverterDateOnly(order.createdOn.seconds)
                        order.dateObject = timeConverterObject(order.createdOn.seconds)
                    }
                    //If rep, check if county in counties
                    if(state.userProfile.isbrewer==10){
                        if(state.userProfile.counties.includes(order.county)) localAllOrders.push(order)
                    }
                    //Not a rep, add
                    else localAllOrders.push(order)
                    store.commit('setAllBreweryOrders', localAllOrders)
                })

            })

            //Get orders which have not been accepted yet
            fb.ordersCollection.where('brewerid', '==', theUidForInventory).where('status', '==', 0).orderBy("createdOn", "desc").onSnapshot(querySnapshot => {
                store.commit('setNewOrdersCount',0)
                let localNewOrders = []
                store.commit('setNewOrders', [])
                querySnapshot.forEach(doc => {
                    store.commit('setNewOrdersCount',state.newBreweryOrdersCount+1)
                    let order = doc.data()
                    order.docId = doc.id
                    if(order.desiredDate){
                        order.desiredTime = new Date(order.desiredDate.seconds*1000)
                        order.deliveryTime = new Date(order.deliveryDate.seconds*1000)
                    } 
                    
                    order.displayStatus="Pending"
                    if (order.createdOn) {
                        order.orderDate = timeConverterDateOnly(order.createdOn.seconds)
                        order.dateObject = timeConverterObject(order.createdOn.seconds)
                    }
                    //If rep, check if county in counties
                    if(state.userProfile.isbrewer==10){
                        if(state.userProfile.counties.includes(order.county)) localNewOrders.push(order)
                    }
                    //Not a rep, add
                    else localNewOrders.push(order)

                    store.commit('setNewOrders', localNewOrders)
                })

            })

            //Get orders which have been accepted
            fb.ordersCollection.where('brewerid', '==', theUidForInventory).where('status', '==', 1).orderBy("createdOn", "desc").onSnapshot(querySnapshot => {
                let localActiveOrders = []
                store.commit('setDeliverSoonCount', 0)
                store.commit('setActiveOrders', [])
                querySnapshot.forEach(doc => {
                    let order = doc.data()
                    order.docId = doc.id
                    order.displayStatus="Accepted"
                    order.deliveryTime = new Date(order.deliveryDate.seconds*1000)
                    if (order.createdOn) {
                        order.orderDate = timeConverterDateOnly(order.createdOn.seconds)
                        order.dateObject = timeConverterObject(order.createdOn.seconds)
                        }

                        //Check if needs to be delivered soon
                        var today = new Date().getTime();
                        var deliveryTimeCalc = order.deliveryDate
                        var timeLeft = (deliveryTimeCalc - today)/1000/60/60
                        
                        //If rep, check if county in counties
                        if(state.userProfile.isbrewer==10){
                            if(state.userProfile.counties.includes(order.county)){
                                localActiveOrders.push(order)
                                if (timeLeft<72) {
                                    store.commit('setDeliverSoonCount', state.deliverSoonCount+1)
                                }
                            } 
                        }
                        //Not a rep, add
                        else{
                            localActiveOrders.push(order)
                            if (timeLeft<72) {
                                store.commit('setDeliverSoonCount', state.deliverSoonCount+1)
                            }
                        } 

                        store.commit('setActiveOrders', localActiveOrders)                                    

                        
                    })
            })

            //Get past orders
            fb.ordersCollection.where('brewerid', '==', theUidForInventory).where('status', 'in', [-1,2]).orderBy("createdOn", "desc").onSnapshot(querySnapshot => {
                var localPastOrders = []
                store.commit('setPastOrders', [])
                querySnapshot.forEach(doc => {
                    let order = doc.data()
                    order.docId = doc.id
                    if (order.createdOn) {
                        order.orderDate = timeConverterDateOnly(order.createdOn.seconds)
                        order.dateObject = timeConverterObject(order.createdOn.seconds)
                    }

                    //Check order status
                    switch(parseInt(order.status)) {
                        case -1:
                            if(order.cancelledBy == 0){
                                var adStr = order.brewer
                                }
                            else{
                                var adStr = order.pub
                                }
                            order.displayStatus="Cancelled by " + adStr
                            break;                                
                        case 2:
                            order.displayStatus="On It's Way!"
                            if(parseInt(order.paid)==1) order.paid = 1
                            break;
                        default:
                            order.displayStatus="Unknown"

                    }
                    
                    //If rep, check if county in counties
                    if(state.userProfile.isbrewer==10){
                        if(state.userProfile.counties.includes(order.county)) localPastOrders.push(order)
                    }
                    //Not a rep, add
                    else localPastOrders.push(order)

                    store.commit('setPastOrders', localPastOrders)
                    })
            })

        },

        //Get Brewery consumer orders
        fetchBreweryConsumerOrders({ commit, state }, data){
            store.commit('setBreweryConsumerOrders', [])
            fb.consumerOrdersCollection.where('brewerid', '==', state.currentUser.uid).orderBy("createdOn", "desc").onSnapshot(querySnapshot => {
                let localAllOrders = []
                querySnapshot.forEach(doc => {
                    let order = doc.data()
                    //console.log("Got consumer order = ")
                    //console.log(order)
                    order.docId = doc.id
                    if (order.createdOn) {
                        order.date = timeConverterDateOnly(order.createdOn.seconds)
                        }
                    
                    order.displayStatus="Pending"
                    if (order.createdOn) {
                        order.orderDate = timeConverterDateOnly(order.createdOn.seconds)
                        order.dateObject = timeConverterObject(order.createdOn.seconds)
                    }
                    localAllOrders.push(order)
                    store.commit('setBreweryConsumerOrders', localAllOrders)
                    //console.log("Consumer brewery orders = ")
                    //console.log(localAllOrders)
                })

            })
            
        },
        //Get consumer orders
        fetchConsumerOrders({ commit, state }, data){
            store.commit('setConsumerOrders', [])
            fb.consumerOrdersCollection.where('pubid', '==', state.currentUser.uid).orderBy("createdOn", "desc").onSnapshot(querySnapshot => {
                let localAllOrders = []
                querySnapshot.forEach(doc => {
                    let order = doc.data()
                    order.docId = doc.id
                    if (order.createdOn) {
                        order.date = timeConverterDateOnly(order.createdOn.seconds)
                        }
                    
                    order.displayStatus="Pending"
                    if (order.createdOn) {
                        order.orderDate = timeConverterDateOnly(order.createdOn.seconds)
                        order.dateObject = timeConverterObject(order.createdOn.seconds)
                    }
                    localAllOrders.push(order)
                    store.commit('setConsumerOrders', localAllOrders)
                })

            })
            
        },
        fetchBreweryEvents({ commit, state }, data){
            store.commit('setBreweryEvents', [])

            fb.eventsCollection.where('brewerid', '==', state.currentUser.uid).onSnapshot(querySnapshot => {
                let eventsArray = []
                store.commit('setBreweryEvents', [])
                querySnapshot.forEach(doc => {
                    let thisEvent = doc.data()
                   if(!thisEvent.cancelled)
                        eventsArray.push(thisEvent)
                })
                store.commit('setBreweryEvents', eventsArray)
    
            })

        },

        /************ CONSUMER BEVERAGES  ****************/
        fetchBeersForConsumer({ commit, state }, data){
            store.commit('setEveryAvailableBeer', [])
            store.commit('setDataLoadingInStoreStatus', true)
            var localBeersList = []
            var localBrewersList = []
            var containersList=["barrel1Quantity", "barrel2Quantity", "canQuantity", "bottleQuantity"]
            var contsumerFields=["consumerBarrel1", "consumerBarrel2", "consumerCan", "consumerBottle"]
            for (var j=0; j<containersList.length; j++){
                var containerQuantity = containersList[j]
                var consumerField = contsumerFields[j]

                
                fb.beersCollection.where("state", "==", state.userProfile.state)
                .where("allowConsumers", "==", 1).where(containerQuantity, ">",0).where(consumerField, "==",1).get().then(docs => {
                    docs.forEach(doc => {
                        //Get minimum price
                        var theBeerData = doc.data()
                        theBeerData.docId = doc.id
                        localBeersList.push(theBeerData)
                        //Add to brewers list
                        localBrewersList.push(theBeerData.uid)
                    })
                }).then(res => {
                    //Remove duplicates
                    var finalBeersList=[]
                    for (var k=0; k<localBeersList.length; k++){
                        var thisBeer=localBeersList[k]
                        const existingBeerindex = finalBeersList.findIndex(item => item.id === thisBeer.id)
                        if (existingBeerindex<0) finalBeersList.push(thisBeer)
                    }
                    store.commit('setDataLoadingInStoreStatus', false)
                    var breweriesList={}
                    breweriesList.independent=localBrewersList
                    breweriesList.distributor=[]
                    store.commit('setEveryAvailableBeer', finalBeersList)
                    store.dispatch('fetchBrewersForUser', breweriesList)
                    })
            }
            
        },
        /************ RETAILER BEVERAGES  ****************/
        fetchBeersForUser({ commit, state }, data){
            store.commit('setDataLoadingInStoreStatus', true)
            store.commit('setEveryAvailableBeer', [])
            var localBeersList = []
            var localBrewersList = []
            var distBreweriesList=[]
            //Get brewery beers
            fb.beersCollection.where("counties", "array-contains", state.userProfile.county).where("state", "==", state.userProfile.state).get().then(docs => {
                docs.forEach(doc => {
                    var theBeerData = doc.data()
                    theBeerData.docId = doc.id

                    //Need to check if quantity exists and is greater than zero. Need to do this as some of these might not exist, causing NaN
                    var barrel1Quantity = 0; var barrel2Quantity = 0; var canQuantity = 0; var bottleQuantity = 0; 
                    if (theBeerData.barrel1Quantity>0&&!isNaN(theBeerData.barrel1Quantity)) barrel1Quantity = theBeerData.barrel1Quantity
                    if (theBeerData.barrel2Quantity>0&&!isNaN(theBeerData.barrel2Quantity)) barrel2Quantity = theBeerData.barrel2Quantity
                    if (theBeerData.canQuantity>0&&!isNaN(theBeerData.canQuantity)) canQuantity = theBeerData.canQuantity
                    if (theBeerData.bottleQuantity>0&&!isNaN(theBeerData.bottleQuantity)) bottleQuantity = theBeerData.bottleQuantity
                    
                    //Get available quantity for multisize
                    var beerAvalQuantity = 0
                    if(theBeerData.multiSize == 1) beerAvalQuantity = Math.max(barrel1Quantity, barrel2Quantity, canQuantity, bottleQuantity)

                    //Get available quantity for old non-multisize
                    else{
                        //check that number is valid
                        if (theBeerData.quantity>0&&!isNaN(theBeerData.quantity))
                        beerAvalQuantity = theBeerData.quantity
                        } 
                    
                    //Check if beer already exists in list
                    const existingBeerindex = localBeersList.findIndex(item => item.id === theBeerData.id);

                    //Remove if qty <= 0
                    if (beerAvalQuantity<=0||isNaN(beerAvalQuantity)){
                        if(existingBeerindex>-1){
                            console.log("Existing beer")
                            localBeersList.splice(existingBeerindex, 1) 
                        }
                    }
                    else  if (beerAvalQuantity>0){
                        //Add beer
                        //For consumers, add only if allowConsumers==1
                        if(state.userProfile.isbrewer==-1){
                            if (theBeerData.allowConsumers=='1'){
                                localBeersList.push(theBeerData)
                                localBrewersList.push(theBeerData.uid)
                            }
                        }
                        //Else, retailer or brewer, add anyway. Distributors cannot sell to consumers
                        else{
                            localBeersList.push(theBeerData)
                            //Add brewer
                            localBrewersList.push(theBeerData.uid)
                            //Check if dist brewery. If yes, add to disbreweries
                            if(theBeerData.distributorId){
                                var distBrewer={uid:theBeerData.distributorId, distbrewerid:theBeerData.distbrewerid, logoFileThumbnailURL:theBeerData.logoFileThumbnailURL, company:theBeerData.brewer, isbrewer:1, distributorName:theBeerData.distributorName}
                                distBreweriesList.push(distBrewer)
                            }
                        }
                        
                        
                    } 

                    })
                }).then(res => {
                    store.commit('setDataLoadingInStoreStatus', false)
                    var breweriesList={}
                    breweriesList.independent=localBrewersList
                    breweriesList.distributor=distBreweriesList
                    store.commit('setEveryAvailableBeer', localBeersList)
                    store.dispatch('fetchBrewersForUser', breweriesList)
                    }).catch(err => {
                        console.log(err)
                        store.commit('setDataLoadingInStoreStatus', false)
                    })
        },
        fetchBrewersForUser({ commit, state }, data){

            var localBrewersList = []
            //Get all brewers. Doing it this way only have to make one call. Then only add this brewer if it's in the brewerslist
            fb.usersCollection.where('isbrewer','>=',1).where("counties", "array-contains", state.userProfile.county).get().then(docs => {
                
                docs.forEach(doc => {
                    var brewerData = doc.data()
                    
                    //console.log('Brewer = ' + brewerData.company)
                    var logoURL
                    if(brewerData.logoFileThumbnailURL) logoURL = brewerData.logoFileThumbnailURL
                    else logoURL = ''
                    
                    //Make sure to not add the brewer more than once
                    //Check independent breweries
                    const favindex = localBrewersList.findIndex(item => item.uid === doc.id);
                    if ((favindex <= -1)) {
                        var brewerObject = {uid: doc.id, isbrewer:brewerData.isbrewer, company: brewerData.company, logoFileThumbnailURL:logoURL, email:brewerData.email, sendOrderEmails:brewerData.sendOrderEmails}
                        localBrewersList.push(brewerObject) 
                    }
                      
                })
                    }).then(res => {
                        store.commit('setDataLoadingInStoreStatus', false)
                        //Find brewers who were in the brewers list received from the beers list
                        var finalBrewersList = []
                        var independentBreweries=data.independent
                        for (var j=0; j<localBrewersList.length; j++){
                            var brewerIndex = independentBreweries.indexOf(localBrewersList[j].uid);
                            if(brewerIndex>-1) finalBrewersList.push(localBrewersList[j])
                        }

                        //Check distributor breweries. Set uid=distributor uid, name and logo = brewery
                        var distBreweries=data.distributor
                        
                        for (var k=0; k<distBreweries.length; k++){
                            //console.log("This dist brewery = ")
                            //console.log(distBreweries[k])
                            var thisDistBrewer=distBreweries[k]
                            //Add only if it doesn't already exist
                            const existingindex = finalBrewersList.findIndex(item => item.distbrewerid === thisDistBrewer.distbrewerid);
                            if(existingindex<0) finalBrewersList.push(thisDistBrewer)
                        }
                        

                        store.commit('setBrewersList', finalBrewersList)
                        })
        },

        fetchAllExistingBeers({ commit, state }, data){
            store.commit('setAllExistingBeers', [])
            var localBeersList = []
            //Get brewery beers
            fb.beersCollection.where("counties", "array-contains", "San Diego").where("state", "==", "CA").get().then(docs => {
                docs.forEach(doc => {
                    var theBeerData = doc.data()
                    theBeerData.docId = doc.id

                    //Need to check if quantity exists and is greater than zero. Need to do this as some of these might not exist, causing NaN
                    var barrel1Quantity = 0; var barrel2Quantity = 0; var canQuantity = 0; var bottleQuantity = 0; 
                    if (theBeerData.barrel1Quantity>0&&!isNaN(theBeerData.barrel1Quantity)) barrel1Quantity = theBeerData.barrel1Quantity
                    if (theBeerData.barrel2Quantity>0&&!isNaN(theBeerData.barrel2Quantity)) barrel2Quantity = theBeerData.barrel2Quantity
                    if (theBeerData.canQuantity>0&&!isNaN(theBeerData.canQuantity)) canQuantity = theBeerData.canQuantity
                    if (theBeerData.bottleQuantity>0&&!isNaN(theBeerData.bottleQuantity)) bottleQuantity = theBeerData.bottleQuantity
                    
                    //Get available quantity for multisize
                    var beerAvalQuantity = 0
                    if(theBeerData.multiSize == 1) beerAvalQuantity = Math.max(barrel1Quantity, barrel2Quantity, canQuantity, bottleQuantity)

                    //Get available quantity for old non-multisize
                    else{
                        //check that number is valid
                        if (theBeerData.quantity>0&&!isNaN(theBeerData.quantity)) beerAvalQuantity = theBeerData.quantity
                        } 
                    
                    //Check if beer already exists in list
                    const existingBeerindex = localBeersList.findIndex(item => item.id === theBeerData.id);

                    //Remove if qty <= 0
                    if (beerAvalQuantity<=0||isNaN(beerAvalQuantity)){
                        if(existingBeerindex>-1){
                            console.log("Existing beer")
                            localBeersList.splice(existingBeerindex, 1) 
                        }
                    }
                    else  if (beerAvalQuantity>0){
                        //Add beer
                        localBeersList.push(theBeerData)
                    } 

                    })
                        }).then(res => {
                                store.commit('setDataLoadingInStoreStatus', false)
                                store.commit('setAllExistingBeers', localBeersList)
                                })
        },

        fetchPubEvents({ commit, state }, data){
            store.commit('setPubEvents', [])
            var arrayLength = state.brewersList.length;

            /************** New code **************/

            for (var i = 0; i < arrayLength; i++) {
                var brewerId = state.brewersList[i].uid
                var today = new Date().getTime();
                var localPubEvents=[]

                fb.eventsCollection.where('brewerid', '==', brewerId).where('cancelled', '==', 0).where('startDate', '>', today).onSnapshot(querySnapshot => {                    
                    querySnapshot.forEach(doc => {
                        var eventData = doc.data()
                        eventData.eventTime = timeConverter(eventData.startTime/1000)
                        eventData.eventTimeObject = timeConverterObject(eventData.startTime/1000)
                        //eventData.eventTime = eventData.startDate
                        eventData.accepted=false
                        var eventAttendees = eventData.attendees
                        //Check if uid is in attendees list
                        for (var m=0; m<eventData.attendees.length; m++){
                            if(eventAttendees[m].attendee.uid == state.currentUser.uid)
                                eventData.accepted=true
                            }
                        //Check if event is full
                        if (eventData.spotsremaining<=0) eventData.full=true
                        else eventData.full = false
                    
                        eventData.docId = doc.id
                        let indextoremove = 999999999999999999999999
                        for (var j in localPubEvents) {
                            if (localPubEvents[j].id == eventData.id) {
                                indextoremove = j
                               break; //Stop this loop, we found it!
                            }
                          }
                          if (indextoremove<999999999999999999999999){
                            localPubEvents.splice(indextoremove,1)
                          }

                        localPubEvents.push(eventData)
                    })
                    store.commit('setPubEvents', localPubEvents)
                    
                })

        }


        },

        updateInventoryQuantity({ commit, state }, data) {
            let beerid = data.id
            let newquantity = data.quantity
            cost = data.cost
            fb.beersCollection.where('id', '==', beerid).where('uid', '==', state.currentUser.uid).get().then(docs => {
                docs.forEach(doc => {
                    fb.beersCollection.doc(doc.id).update({
                        quantity: newquantity,
                        cost: cost
                    })
                })
            }).catch(err => {
                console.log(err)
            })
            
        },
        /*****************************************/
        /****** Get all messages for a user ******/
        /*****************************************/
        getUserMessages({ commit, state }, data){
                var keyForMessages
                if(parseInt(state.userProfile.isbrewer)==1||parseInt(state.userProfile.isbrewer)==2) keyForMessages ='messageinfo.brewerId'
                else keyForMessages ='messageinfo.pubId'
                
                //First get messages for pubid
                fb.messagesCollection.where('messageinfo.pubId', '==', state.currentUser.uid).orderBy("messageinfo.createdOn", "desc").onSnapshot(querySnapshot => {
                    var messagesArray = []
                    store.commit('setUnreadCount', 0)
                    querySnapshot.forEach(doc => {
                        let theMessage = doc.data()
                        theMessage.docId = doc.id
                        //Format date
                        if (theMessage.messageinfo.createdOn) {
                            theMessage.date = timeConverter(theMessage.messageinfo.createdOn.seconds)
                        }
                        //Check if unread by this user
                        if((theMessage.messageinfo.senderId!=state.currentUser.uid)&&parseInt(theMessage.messageinfo.readByReceiver)==0){
                            theMessage.unreadByUser = 1
                            store.commit('setUnreadCount', state.unreadCount+1)
                        }

                        //Check who the conversation is with
                        if(theMessage.messageinfo.pubId==state.currentUser.uid) theMessage.conversationWith = theMessage.messageinfo.brewerName
                        else theMessage.conversationWith = theMessage.messageinfo.pubName

                        //Update unread count
                        //if (theMessage.read == 0 ) store.commit('setUnreadCount', state.unreadCount+1)

                        //Check if already exists. If exists, replace
                        var thismessageindex = messagesArray.findIndex(item => item.docId === theMessage.docId);
                        if(thismessageindex>=0){
                            messagesArray.splice(thismessageindex, 1, theMessage);
                        }
                        else messagesArray.push(theMessage)
                    })

                    //Next get message for brewerid
                    fb.messagesCollection.where('messageinfo.brewerId', '==', state.currentUser.uid).orderBy("messageinfo.createdOn", "desc").onSnapshot(querySnapshot => {
                        querySnapshot.forEach(doc => {
                            let theMessage = doc.data()
                            theMessage.docId = doc.id
                            //Format date
                            if (theMessage.messageinfo.createdOn) {
                                theMessage.date = timeConverter(theMessage.messageinfo.createdOn.seconds)
                            }
                            //Check if unread by this user
                            if((theMessage.messageinfo.senderId!=state.currentUser.uid)&&parseInt(theMessage.messageinfo.readByReceiver)==0){
                                theMessage.unreadByUser = 1
                                store.commit('setUnreadCount', state.unreadCount+1)
                            }
                            //Check who the conversation is with
                            if(theMessage.messageinfo.pubId==state.currentUser.uid) theMessage.conversationWith = theMessage.messageinfo.brewerName
                            else theMessage.conversationWith = theMessage.messageinfo.pubName

                            //Update unread count
                            //if (theMessage.read == 0 ) store.commit('setUnreadCount', state.unreadCount+1)

                            //Check if already exists. If exists, replace
                            var thismessageindex = messagesArray.findIndex(item => item.docId === theMessage.docId);
                            if(thismessageindex>=0){
                                messagesArray.splice(thismessageindex, 1, theMessage);
                            }
                            else messagesArray.push(theMessage)
                        })
                    })

                    store.commit('setUserMessagesArray', messagesArray)
                })
        },
        getUserMessages2({ commit, state }, data){
            var keyForMessages
            if(parseInt(state.userProfile.isbrewer)==1||parseInt(state.userProfile.isbrewer)==2) keyForMessages ='messageinfo.brewerId'
            else keyForMessages ='messageinfo.pubId'
            
            fb.messagesCollection.where(keyForMessages, '==', state.currentUser.uid).orderBy("messageinfo.createdOn", "desc").onSnapshot(querySnapshot => {
                let messagesArray = []
                store.commit('setUnreadCount', 0)
                querySnapshot.forEach(doc => {
                    let theMessage = doc.data()
                    theMessage.docId = doc.id
                    //Format date
                    if (theMessage.messageinfo.createdOn) {
                        theMessage.date = timeConverter(theMessage.messageinfo.createdOn.seconds)
                    }
                    
                    //Check who the conversation is with
                    if(theMessage.messageinfo.pubId==state.currentUser.uid) theMessage.conversationWith = theMessage.messageinfo.brewerName
                    else theMessage.conversationWith = theMessage.messageinfo.pubName

                    //Check if unread by this user
                    if((theMessage.messageinfo.senderId!=state.currentUser.uid)&&parseInt(theMessage.messageinfo.readByReceiver)==0){
                        theMessage.unreadByUser = 1
                        store.commit('setUnreadCount', state.unreadCount+1)
                    }
                    if (theMessage.read == 0 ) store.commit('setUnreadCount', state.unreadCount+1)
                    messagesArray.push(theMessage)
                })
                store.commit('setUserMessagesArray', messagesArray)
            })
    },

        getSingleMessageThread({ commit, state }, data){
            console.log("Getting messageinfo.id=" + data)
            fb.messagesCollection.where('messageinfo.id', '==', data).onSnapshot(querySnapshot => {
                let messagesArray = []
                querySnapshot.forEach(doc => {
                    let theMessage = doc.data()
                    var msgArray = theMessage.messages
                    for (var i in msgArray) {
                        var thisMessage = msgArray[i].message
                        //Format date
                        if (thisMessage.createdOn) {
                            var thisDate = timeConverter(thisMessage.createdOn.seconds)
                            thisMessage.date = thisDate
                            }

                        //Check if use is sender
                        if (thisMessage.senderId == state.currentUser.uid) thisMessage.iAmSender = 1
                        else thisMessage.iAmSender = 0
                        messagesArray.push(thisMessage)
                      }
                })
                var truncatedMessagesArray = []
                var displayLength = 20
                var mesagesLength = messagesArray.length

                if (mesagesLength<=displayLength){
                    truncatedMessagesArray = messagesArray
                }
                else{
                    var start = mesagesLength - displayLength - 1
                    for (var j=start; j<mesagesLength; j++){
                        truncatedMessagesArray.push(messagesArray[j])
                    } 
                }

                store.commit('setSingleMessageThread', truncatedMessagesArray)
            })
        },
        unFavorite({ commit, state }, brewerId){
            var localFavoriteBrewers = []
            var arrayLength = state.favoriteBrewersList.length;
            for (var i = 0; i < arrayLength; i++) {
                if (state.favoriteBrewersList[i]!=brewerId) localFavoriteBrewers.push(state.favoriteBrewersList[i])
            }
            store.commit('setFavoriteBrewersList', localFavoriteBrewers)
            fb.usersCollection.doc(state.currentUser.uid).update({favorites:localFavoriteBrewers})
        },
        addToNewsFeed({ commit, state }, newsData){
            var dataToAdd= {}
            dataToAdd.sentBy = state.currentUser.uid
            dataToAdd.createdOn = new Date()

            dataToAdd.pubId = newsData.pubId
            dataToAdd.brewerId = newsData.brewerId
            dataToAdd.feedString = newsData.feedString

            dataToAdd.senderName = state.userProfile.company
            fb.newsfeedCollection.add(dataToAdd)
        },
        addBeerToCartMultisize({ commit, state }, theBeer){
            //console.log("Adding in store ")
            //console.log(theBeer)
            var existingCart = state.userCart
            if(!existingCart) existingCart=[]
            
            //Check if this beer already exists in the cart. If already exists, just update quantity
            var cartLength = existingCart.length
            var matchFound = false
            if (cartLength>0){
                for (var i in existingCart){
                    var existingBeer = existingCart[i]
                    //Match beer ID
                    if(existingBeer.id == theBeer.id){
                        //Match container
                        if (existingBeer.container == theBeer.container){
                            //Match found. Replace quantity in cart
                            matchFound = true
                            existingBeer.orderQuantity = existingBeer.orderQuantity + theBeer.orderQuantity
                            var orderCost = parseFloat(existingBeer.orderQuantity) * parseFloat(existingBeer.cost)
                            existingBeer.orderCost=orderCost
                            //Replace cart item with new beer
                            existingCart.splice(i, 1, existingBeer);
                        }
                    }
                }
            }
            //Beer doesn't exist in cart. Add to cart
            if(!matchFound){
                var orderCost = parseFloat(theBeer.orderQuantity) * parseFloat(theBeer.cost)
                theBeer.orderCost=orderCost
                existingCart.push(theBeer)
                store.commit('setCartCount', state.cartCount+1)
            } 
            store.commit('setUserCartMultisize', existingCart)
            

        },

        //Add to consumer cart
        addToConsumerCart({ commit, state }, theBeer){
            var existingCart = state.consumerCart
            //Check of this brewer exists in the cart already
            var existingBrewerIndex = existingCart.findIndex(item => item.brewerid === theBeer.brewerid);
            //If brewer found, append or update item
            if(existingBrewerIndex>-1){
                var thisBrewerCart = existingCart[existingBrewerIndex]
                var cartItems = thisBrewerCart.cartItems
                var matchFound = false
                //Check if already in cart. Update qty if needed
                var thisbeerindex = cartItems.findIndex(item => item.id === theBeer.id);
                if(thisbeerindex>-1){
                    //Beer found in cart, iterate over all items and check if container exists
                    for (var k=0; k<cartItems.length; k++){
                        var thisBeerItem = cartItems[k]
                        if (thisBeerItem.container == theBeer.container){
                            matchFound = true
                            console.log("Match found")
                            thisBeerItem.orderQuantity = thisBeerItem.orderQuantity + theBeer.orderQuantity
                            cartItems.splice(k, 1, thisBeerItem)
                            thisBrewerCart.cartItems=cartItems
                        }
                    }
                if(!matchFound) cartItems.push(theBeer)
                thisBrewerCart.cartItems = cartItems
                //Update cart items
                existingCart.splice(existingBrewerIndex, 1, thisBrewerCart);
                }
            }
            //If brewer not found, create brewer item
            else{
                var newBrewer = {}
                newBrewer.brewerid = theBeer.brewerid
                newBrewer.brewer = theBeer.brewer
                var cartItems=[]
                cartItems.push(theBeer)
                newBrewer.cartItems = cartItems
                existingCart.push(newBrewer)
            }
            store.commit('setConsumerCart', existingCart)
        },

        updateDeliveryZipCodesAsync({ commit, state }, radius){
            var url = 'https://api.zip-codes.com/ZipCodesAPI.svc/1.0/FindZipCodesInRadius?zipcode=' + state.userProfile.zip + '&maximumradius='+radius+'&minimumradius=0&key=PL3MRXQX8L40JDTW1PPX' 
            var zipList = []
            axios
            .get(url)
            .then(function(resp) {

                var theData = resp.data
                var dataList = theData.DataList
                var zipCodeslength = dataList.length

                //var arrayLength = resp.data.DataList.length;
                for (var i = 0; i < zipCodeslength; i++) {
                    zipList.push(dataList[i].Code)
                    }
                        fb.usersCollection.doc(state.currentUser.uid).update({
                            zipcodes: zipList,
                            radius:radius
                        })

            })

        },

        updateDeliveryZipCodesWithNewZipAsync({ commit, state }, zipcode){
            var url = 'https://api.zip-codes.com/ZipCodesAPI.svc/1.0/FindZipCodesInRadius?zipcode=' + zipcode+ '&maximumradius='+state.userProfile.radius+'&minimumradius=0&key=PL3MRXQX8L40JDTW1PPX' 
            var zipList = []
            axios
            .get(url)
            .then(function(resp) {
                var theData = resp.data
                var dataList = theData.DataList
                var zipCodeslength = dataList.length
                for (var i = 0; i < zipCodeslength; i++) {
                    zipList.push(dataList[i].Code)
                    }
                        fb.usersCollection.doc(state.currentUser.uid).update({
                            zipcodes: zipList
                        })

            })
        },
        getUserAddressFromIP({ commit, state }, newsData){

            console.log("Getting IP")
            axios({
                method: 'get',
                url: "https://api.ipify.org?format=json"

            }).then(
                response => {
                    var ipaddress = response.data.ip
                    //console.log(ipaddress)

                    var locationURL = "https://ipapi.co/" + ipaddress +"/json"
                    //Get location
                    axios({
                        method: 'get',
                        url: locationURL
        
                    }).then(
                        response => {
                            var address = response.data
                            //console.log("Returning ")
                            //console.log(address)
                            var city = address.city
                            var state = address.region_code
                            //console.log("City = " + city + " State = " + state)
                            store.commit('setUserAddressFromIP', address)
                        },
                        reject => {
                            console.log(reject)
                        }
                    )
                    //End of location
                },
                reject => {
                    console.log(reject)
                }
            )
        },
        
        //Sales tax
        getSalesTax({ commit, state }, newsData){
            console.log("Getting sales tax")
            axios({
                method:'get',
                url:'https://rest.avatax.com/api/v2/taxrates/bypostalcode?country=USA&postalCode=92122',
                headers: {'Authorization': 'Basic ' + ' bWFoaW1Aa2Vnc2Vla2VyLmNvbTprYW5nYXJvb0BLUw=='}
              })
                .then(function (response) {
                  console.log(response.data);
                })
                .catch(function (error) {
                  console.log(error.response.data);
                });

        },

 
    },
    mutations: {
        setCurrentUser(state, val) {
            state.currentUser = val
        },
        setUserProfile(state, val) {
            state.userProfile = val
        },
        setUserProfileStatus(state, val) {
            state.userProfileStatus = val
        },
        setUserInventory(state, val) {
            state.userInventory = val
        },
        setUserPromotedInventory(state, val) {
            state.userPromotedInventory = val
        },
        setBreweryEvents(state, val) {
            state.breweryEvents = val
        },
        setIsBrewer(state, val) {
            state.isBrewer = val
        },

        setUserSentMessages(state, val) {
            state.userSentMessages = val
        },
        setUserReceivedMessages(state, val) {
            state.userReceivedMessages = val
        },
        setUserMessagesArray(state, val) {
            state.userMessagesArray = val
        },

        //Append to messages array
        appendToUserMessagesArray(state, val) {
            state.userMessagesArray.push(val)
        },

        setSingleMessageThread(state, val) {
            state.singleMessageThread = val
        },
        setActiveMessageThreadInfo(state, val){
            state.activeMessageThreadInfo = val
        },
        setUnreadCount(state, val) {
            state.unreadCount = val
        },
        setAllBreweryOrders(state, val) {
            state.allBreweryOrders = val
        },
        setPendingOrders(state, val) {
            state.pendingOrders = val
        },
        setAcceptedOrders(state, val) {
            state.acceptedOrders = val
        },
        setPastOrders(state, val) {
            state.pastOrders = val
        },
        setNewOrdersCount(state, val) {
            state.newBreweryOrdersCount = val
        },
        setViewingBrewerId(state, val) {
            state.viewingBrewerId = val
        },
        setViewingBrewerName(state, val) {
            state.viewingBrewerName = val
        },
        setCartCount(state, val) {
            state.cartCount = val
        },
        setConsumerCartCount(state, val) {
            state.consumerCartCount = val
        },

        setEveryAvailableBeer(state,val){

            //Insert promoted beers in beers list
            var tempBeersList = []
            var promotedBeersCount = state.promotedBeers.length

            //First add promoted beers
            for (var j=0; j<promotedBeersCount; j++) {
                var promotedBeer = state.promotedBeers[j]
                promotedBeer.isBeingPromoted = true
                tempBeersList.push(state.promotedBeers[j])
            }

            //Shuffle array
            function shuffleArray(array) {
                for (let i = array.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [array[i], array[j]] = [array[j], array[i]];
                }
                return array
            }
            val = shuffleArray(val)
            //Now add the others
            var allBeersCount = val.length
            for (var i = 0; i <allBeersCount; i ++){
                val[i].isBeingPromoted = false
                tempBeersList.push(val[i])
            }
            state.everyAvailableBeer=tempBeersList
        },
        setBreweryBeerCount(state,val){
            console.log("In setbrewerycount")
            console.log("setting for id = " + val.uid)
            console.log("setting count = " + val.beersCount)
            const favindex = state.brewersList.findIndex(item => item.uid === val.uid);
            if(favindex>-1){
                console.log("Found brewer")
                state.brewersList[favindex].beersCount = val.beersCount
            }
            

        },
        setPromotedBeers(state,val){
            state.promotedBeers=val
        },
        setFavoriteBeersList(state,val){
            state.favoriteBeersList=val
        },
        setFavoriteBrewersList(state,val){
            state.favoriteBrewersList=val
        },
        setPubEvents(state,val){
            state.pubEvents=val
        },

        setBrewersList(state,val){
            state.brewersList=val
        },

        setDistributorList(state,val){
            state.distributorList=val
        },
        setDeliverSoonCount(state,val){
            state.deliverSoonCount=val
        },

        setNewOrders(state,val){
            state.newOrders=val
        },

        setActiveOrders(state,val){
            state.activeOrders=val
        },
        setCompletedOrders(state,val){
            state.completedOrders=val
        },

        setNewsFeed(state,val){
            state.newsFeed=val
        },
        setDataLoadingInStoreStatus(state,val){
            state.dataLoadingInStoreStatus=val
        },
        setPromotionsEnabled(state,val){
            state.promotionsEnabled = val
        },

        setUserAddressFromIP(state,val){
            state.userAddressFromIP = val
        },
        setAllowDistributors(state, val){
            state.allowDistributors = val
        },
        setAllBrewersList(state, val){
            state.allBrewersList = val
        },
        setDistributorBreweries(state, val){
            state.distributorBreweries = val
        },
        setDistributorBeers(state, val){
            state.distributorBeers = val
        },

        addToCart(state,val){
            if(val){
                var availableQty=parseInt(val.available)
                var arrayLength = state.userCart.length
                //Check if already in cart, if already in cart, increment quantity
                if(arrayLength>0){
                    for (var i in state.userCart) {
                        if (state.userCart[i].id == val.id) {
                            state.userCart[i].orderQuantity = parseInt(val.orderQuantity) + parseInt(state.userCart[i].orderQuantity );
                            if (state.userCart[i].orderQuantity>availableQty) state.userCart[i].orderQuantity = availableQty
                            break
                        }
                        else{
                            state.userCart.push(val)
                            store.commit('setCartCount', state.cartCount+1)
                            break
                          }

                      }
                }
                else{
                    state.userCart.push(val)
                    store.commit('setCartCount', state.cartCount+1)
                }
                const favindex = state.everyAvailableBeer.findIndex(item => item.id === val.id);
                state.everyAvailableBeer[favindex].orderquantity = ""

            }
        },
        setUserCartMultisize(state,val){
            state.userCart = val
        },
        addToCartNew(state, val){
            state.userCart.push(val)
        },

        deleteItemFromCart(state,suborderid){
            store.commit('setCartCount', state.cartCount-1)
            let indextoremove = 999999999999999999999999

            for (var i in state.userCart) {
                if (state.userCart[i].suborderid == suborderid) {
                    indextoremove = i
                   break; //Stop this loop, we found it!
                }
              }
              if (indextoremove<999999999999999999999999){
                state.userCart.splice(indextoremove,1)
              }

        },
        //Update retailer quantity
        updateQuantityInCart(state,toupdate){
            var cartList = []
                for (var i in state.userCart) {
                    var theCartObject = state.userCart[i]
                  if (state.userCart[i].suborderid == toupdate.suborderid) {
                      
                      theCartObject.orderQuantity = parseInt(toupdate.orderQuantity)
                      //Update cost of item
                      theCartObject.orderCost = parseFloat(theCartObject.cost)*theCartObject.orderQuantity
                      if (theCartObject.orderQuantity>toupdate.availableQuantity) theCartObject.orderQuantity = toupdate.availableQuantity
                      //This loses reactivity
                    state.userCart[i].orderQuantity = parseInt(theCartObject.orderQuantity);
                  }
                  //Need to recreate cart with this one
                  cartList.push(theCartObject)
                }
                state.userCart = cartList
                
        },

        //Update consumer quantity
        updateConsumerQuantityInCart(state,toupdate){

        },

        //Final checkout cart
        setCheckoutCart(state, val){
            state.checkoutCart = val
        },
        emptyCheckoutCart(state, val){
            state.checkoutCart = []
        },
        emptyConsumerCart(state, val){
            state.consumerCart = []
        },
        setCartCost(state, val){
            state.cartCost=val
        },
        emptyCart(state,val){
            state.userCart=[]
            store.commit('setCartCount', 0)
            store.commit('setConsumerCartCount', 0)
        },
        setBeerFilter(state,val){
            state.beerFilter = val
        },
        setShowingSearchResults(state,val){
            state.showingSearchResults = val
        },
        setShowingAllResults(state,val){
            state.showingAllResults = val
        },
        setSearchBeerList(state,val){
            state.searchBeerList = val
        },
        setDisplaySearchPhrase(state,val){
            state.displaySearchPhrase = val
        },
        setAllowInvoice(state,val){
            state.allowInvoice = val
        },
        setInvoicesArray(state,val){
            state.invoicesArray = val
        },
        setOrdersToInvoice(state,val){
            state.ordersToInvoice = val
        },
        setAllExistingBeers(state,val){
            state.allExistingBeers = val
        },
        setAllowConsumers(state,val){
            state.allowConsumers = val
        },
        setConsumerOrders(state,val){
            state.consumerOrders = val
        },

        //Set consumer cart. Calculate total order cost, shipping, delivery etc.
        setConsumerCart(state,val){
            state.consumerCart=[]
            //Check for empty cart
            if (val.length<=0) return

            //To find total number of items
            var totalItems = 0

            //Iterate over breweries
            for (var i=0; i<val.length; i++){
                var thisBrewerCart = val[i]
                var totalCans = 0
                var totalItemsCost = 0
                var kegseekerfees=2.99

                var minForFreeDelivery = 9999
                var minForFreeShipping = 9999
                var consumerDeliveryFees = 0
                var kegDeposit=0
                var mainorderid=''
                var brewerid=''
                var buyerNote=''
                var availableDeliveryOptions=['Free Pickup', 'Deliver', 'Ship']

                //Iterate over items for this brewery to calculate items cost, total items
                for (var k=0; k<thisBrewerCart.cartItems.length; k++){
                    var thisCartItem = thisBrewerCart.cartItems[k]
                    totalItems = totalItems + 1

                    //Check all delivery options. If a delivery option is missing from an item, remove it for the entire order
                    var pickup = thisCartItem.deliveryOptions.includes("Free Pickup")
                    if(!pickup){
                        var pickupIndex = availableDeliveryOptions.findIndex(item => item == "Free Pickup");
                        if(pickupIndex>-1) availableDeliveryOptions.splice(pickupIndex, 1)
                    }
                    var deliver = thisCartItem.deliveryOptions.includes("Deliver")
                    if(!deliver){
                        var deliverIndex = availableDeliveryOptions.findIndex(item => item == "Deliver");
                        if(deliverIndex>-1) availableDeliveryOptions.splice(deliverIndex, 1)
                    }
                    var ship = thisCartItem.deliveryOptions.includes("Ship")
                    if(!ship){
                        var shipIndex = availableDeliveryOptions.findIndex(item => item == "Ship");
                        if(shipIndex>-1){
                            availableDeliveryOptions.splice(shipIndex, 1)
                        } 
                    }
                    
                    if(thisCartItem.minForFreeDelivery) minForFreeDelivery = thisCartItem.minForFreeDelivery
                    if (thisCartItem.minForFreeShipping) minForFreeShipping = thisCartItem.minForFreeShipping

                    mainorderid = thisCartItem.mainorderid
                    brewerid = thisCartItem.uid
                    consumerDeliveryFees = thisCartItem.consumerDeliveryFees

                    //Calculate total number of bottles and cans in cart for this brewer
                    if(thisBrewerCart.cartItems[k].container=="can")
                        totalCans = totalCans + thisBrewerCart.cartItems[k].orderQuantity*thisBrewerCart.cartItems[k].canConsumerCaseSize

                    if(thisBrewerCart.cartItems[k].container=="bottle")
                        totalCans = totalCans + thisBrewerCart.cartItems[k].orderQuantity*thisBrewerCart.cartItems[k].bottleConsumerCaseSize

                    //Calculate total brewer items cost and deposit
                    if (thisCartItem.container=="barrel1"){
                        totalItemsCost = totalItemsCost + thisCartItem.barrel1ConsumerCost*thisCartItem.orderQuantity
                        if(parseFloat(thisCartItem.kegDeposit)>0) kegDeposit = kegDeposit + thisCartItem.kegDeposit*thisCartItem.orderQuantity
                        
                    }
                    else if (thisCartItem.container=="barrel2"){
                        totalItemsCost = totalItemsCost + thisCartItem.barrel2ConsumerCost*thisCartItem.orderQuantity
                        if(parseFloat(thisCartItem.kegDeposit)>0) kegDeposit = kegDeposit + thisCartItem.kegDeposit*thisCartItem.orderQuantity

                    }
                    else if (thisCartItem.container=="can"){
                        totalItemsCost = totalItemsCost + thisCartItem.canConsumerCost*thisCartItem.orderQuantity
                    }
                    else if (thisCartItem.container=="bottle"){
                        totalItemsCost = totalItemsCost + thisCartItem.bottleConsumerCost*thisCartItem.orderQuantity
                    }
                }
                //End of iteration over cart items

                //Brewer costs
                thisBrewerCart.totalCans=totalCans
                thisBrewerCart.totalItemsCost=totalItemsCost
                thisBrewerCart.kegseekerfees=kegseekerfees

                //Check if min of 24 cans/bottles is satisfied
                if(totalCans<=0||totalCans>=24) thisBrewerCart.minCanCountOK = 1
                else thisBrewerCart.minCanCountOK = 0

                //Find shipping cost of cases. Get from first cart item
                //Brewer might not have entered case sizes in order. Case2size might be smaller than case1size
                
                var maxShippingFees = 0
                var userShippingFees = 9999
                thisBrewerCart.deliveryCost = 0
                thisBrewerCart.shippingCost = 0

                // Check if a delivery option was already selected, and is stil available
                thisBrewerCart.availableDeliveryOptions = availableDeliveryOptions
                if(!(thisBrewerCart.selectedDeliveryOption&&availableDeliveryOptions.includes(thisBrewerCart.selectedDeliveryOption))) 
                    thisBrewerCart.selectedDeliveryOption=""

                /*******************************/
                //Calculate shipping cost
                /*******************************/
                if(totalCans>0)
                {
                    //Check all case sizes and compute shipping cost
                    if(thisBrewerCart.cartItems[0].case1ShippingSize>0){
                        if(thisBrewerCart.cartItems[0].case1ShippingCost>maxShippingFees) maxShippingFees = thisBrewerCart.cartItems[0].case1ShippingCost
                        if(totalCans<=thisBrewerCart.cartItems[0].case1ShippingSize*24){
                            if(thisBrewerCart.cartItems[0].case1ShippingCost<userShippingFees) userShippingFees = thisBrewerCart.cartItems[0].case1ShippingCost
                        } 
                    }
                    if(thisBrewerCart.cartItems[0].case2ShippingSize>0){
                        if(thisBrewerCart.cartItems[0].case2ShippingCost>maxShippingFees) maxShippingFees = thisBrewerCart.cartItems[0].case2ShippingCost
                        if(totalCans<=thisBrewerCart.cartItems[0].case2ShippingSize*24){
                            if(thisBrewerCart.cartItems[0].case2ShippingCost<userShippingFees) userShippingFees = thisBrewerCart.cartItems[0].case2ShippingCost
                        } 
                    }
                    if(thisBrewerCart.cartItems[0].case3ShippingSize>0){
                        if(thisBrewerCart.cartItems[0].case3ShippingCost>maxShippingFees) maxShippingFees = thisBrewerCart.cartItems[0].case3ShippingCost
                        if(totalCans<=thisBrewerCart.cartItems[0].case3ShippingSize*24){
                            if(thisBrewerCart.cartItems[0].case3ShippingCost<userShippingFees) userShippingFees = thisBrewerCart.cartItems[0].case3ShippingCost
                        } 
                    }
                    if(thisBrewerCart.cartItems[0].case4ShippingSize>0){
                        if(thisBrewerCart.cartItems[0].case4ShippingCost>maxShippingFees) maxShippingFees = thisBrewerCart.cartItems[0].case4ShippingCost
                        if(totalCans<=thisBrewerCart.cartItems[0].case4ShippingSize*24){
                            if(thisBrewerCart.cartItems[0].case4ShippingCost<userShippingFees) userShippingFees = thisBrewerCart.cartItems[0].case4ShippingCost
                        } 
                    }
                    
                }

                //Add min for free delivery and shipping
                thisBrewerCart.minForFreeDelivery = minForFreeDelivery
                thisBrewerCart.minForFreeShipping = minForFreeShipping
                thisBrewerCart.mainorderid = mainorderid

                /**********************/
                //Set delivery cost
                /**********************/

                if(parseFloat(thisBrewerCart.totalItemsCost)>=parseFloat(minForFreeDelivery)||parseFloat(thisBrewerCart.totalItemsCost)<=0)
                    thisBrewerCart.deliveryCost = 0
                else thisBrewerCart.deliveryCost = parseFloat(consumerDeliveryFees)

                /**********************/
                //If shipping fees is 9999, it means user ordered more than max shipping size. In that case, use max shipping fees
                /**********************/
                if (userShippingFees==9999) thisBrewerCart.shippingCost = maxShippingFees
                else thisBrewerCart.shippingCost = parseFloat(userShippingFees)
                
                /**********************/
                //Check if min for free shipping is met
                /**********************/
                if(parseFloat(thisBrewerCart.totalItemsCost)>=parseFloat(minForFreeShipping)||parseFloat(thisBrewerCart.totalItemsCost)<=0)
                    thisBrewerCart.shippingCost = 0

                //Set keg deposit 
                thisBrewerCart.kegDeposit = kegDeposit

                //Get shipping and billing address
                var billingaddress = state.userProfile.street1
                if(state.userProfile.street2) billingaddress = billingaddress + ', ' + state.userProfile.street2
                billingaddress = billingaddress + ', ' + state.userProfile.city + ', ' + state.userProfile.state + ', ' + state.userProfile.zip

                thisBrewerCart.billingaddress = billingaddress
                //Sometimes get wrong dates. Must do it twice.
                thisBrewerCart.createdOn = new Date()
                thisBrewerCart.createdOn = new Date()
                thisBrewerCart.status=0
                thisBrewerCart.pubid=state.currentUser.uid
                thisBrewerCart.brewerid=brewerid
                thisBrewerCart.pub=state.userProfile.company
                thisBrewerCart.fromapp=0
                thisBrewerCart.buyerNote=buyerNote

                //Calculate tax
                var tax = parseFloat(state.userProfile.salestax)
                tax = tax * thisBrewerCart.totalItemsCost
                thisBrewerCart.tax=tax
                //Add tax rate
                if(state.userProfile.salestax) thisBrewerCart.taxrate = state.userProfile.salestax

                //Add total cost, without KS fees
                thisBrewerCart.totalCost = tax + parseFloat(thisBrewerCart.totalItemsCost) + parseFloat(thisBrewerCart.kegDeposit)
                
                if (thisBrewerCart.selectedDeliveryOption == "Deliver") 
                    thisBrewerCart.totalCost = thisBrewerCart.totalCost + parseFloat(thisBrewerCart.deliveryCost)
                if (thisBrewerCart.selectedDeliveryOption == "Ship") 
                    thisBrewerCart.totalCost = thisBrewerCart.totalCost + parseFloat(thisBrewerCart.shippingCost)

                thisBrewerCart.totalCost=parseFloat(thisBrewerCart.totalCost)
                
                //Add only if cart items length is > 0
                if (thisBrewerCart.cartItems.length>0) state.consumerCart.push(thisBrewerCart)
            }
            store.commit('setConsumerCartCount', totalItems)
            //End of iteration over breweries
            console.log("Cart = ")
            console.log(state.consumerCart)

        },
        //Brewery consumer orders
        setBreweryConsumerOrders(state,val){
            state.breweryConsumerOrders=val
        },

        //Brewer service requests
        setBrewerServiceRequests(state,val){
            state.brewerServiceRequests=val
        },
        //Brewer open service requests
        setOpenServiceRequests(state,val){
            state.openServiceRequests=val
        },

        //Set if consumer has selected business or consumer website
        setSelectedConsumerWebsite(state,val){
            state.selectedConsumerWebsite = val
        },

        //Allow advertising:
        setAllowAdvertising(state,val){
            state.allowAdvertising = val
        },

        //UI Version
        setUiVersion(state,val){
            state.uiVersion=val
        },


        //Set selected distributor brewery
        setSelectedDistBrewery(state,val){
            state.selectedDistBrewery=val
        },
        //Forums
        setAllowForums(state,val){
            state.allowForums=val
        },

        //Selected sale item
        setSelectedSaleItem(state,val){
            state.selectedSaleItem=val
        },

        //Set new item being setup for sale
        setCreatedItemForSale(state,val){
            state.createdItemForSale=val
        },

        //Camera image id
        setCameraImageId(state,val){
            state.cameraImageId=val
        },
        //Camera image url
        setCameraImageUrl(state,val){
            state.cameraImageUrl=val
        },
        //Camera captured images
        setCapturedImages(state,val){
            console.log("Captured images = ")
            console.log(val)
            state.capturedImages=val
        },

        //Current forum thread id
        setCurrentForumThreadId(state,val){
            state.currentForumThreadId=val
        },

        //New user
        setNewUserCompany(state,val){
            state.newUserCompany=val
        },
        setNewUserEmail(state,val){
            state.newUserEmail=val
        },
        setNewUserPassword(state,val){
            state.newUserPassword=val
        },
        setNewUserIsBrewer(state,val){
            state.newUserIsBrewer=val
        },
        setNewUserAddress(state,val){
            console.log("Saving address to store")
            console.log(val)
            state.newUserAddress=val
        },
        setNewUserContactName(state,val){
            state.newUserContactName=val
        },
        setNewUserContactPhone(state,val){
            state.newUserContactPhone=val
        },
        setNewUserTermsAccepted(state,val){
            state.newUserTermsAccepted=val
        },
        setNewUserCounties(state,val){
            state.newUserCounties=val
        },
        setAllowCoupons(state,val){
            state.allowCoupons=val
        },
        
    },
    
})
